import { getComputedStyle } from '../dom/element';

export function getBorderTopWidthForElement(element: Element): number | null {
  return getPropertyValueAsNumber(element, 'border-top-width');
}

export function getBorderLeftWidthForElement(element: Element): number | null {
  return getPropertyValueAsNumber(element, 'border-left-width');
}

export function getBorderLeftColorForElement(element: Element): string | null {
  return getPropertyValueAsString(element, 'border-left-color');
}

export function getBorderTopColorForElement(element: Element): string | null {
  return getPropertyValueAsString(element, 'border-top-color');
}

function getPropertyValueAsNumber(element: Element, property: string): number | null {
  const computedStyle = getComputedStyle(element);
  if (computedStyle === null) {
    return null;
  }
  const propertyValue = computedStyle.getPropertyValue(property);
  if (propertyValue === null) {
    return null;
  }
  const match = propertyValue.trim().match(/([\d]+(?:\.[\d]+)?)px/);
  if (!match || !match[0]) {
    return null;
  }
  return parseInt(match[0], 10);
}

function getPropertyValueAsString(element: Element, property: string): string | null {
  const computedStyle = getComputedStyle(element);
  if (computedStyle === null) {
    return null;
  }
  return computedStyle.getPropertyValue(property);
}
